var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherCloudyMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.299 36.3294C43.299 48.948 53.5309 59.18 66.1495 59.18C78.7681 59.18 89 48.948 89 36.3294C89 23.7108 78.7681 13.4789 66.1495 13.4789C53.5309 13.4789 43.299 23.7108 43.299 36.3294Z",
    fill: "url(#paint0_radial_646_34198)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1881 40.3665C52.3377 40.1719 53.8696 37.7345 53.6157 34.9247C53.3618 32.115 51.4152 29.9907 49.2741 30.1854C47.1244 30.38 45.5926 32.8174 45.8465 35.6272C46.1004 38.4369 48.0469 40.5612 50.1881 40.3665Z",
    fill: "#ACADB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3262 42.4145C47.0398 43.0916 46.7182 45.0043 47.5983 46.6885C48.4785 48.3726 50.2388 49.1936 51.5252 48.5165C52.8116 47.8394 53.1332 45.9268 52.2531 44.2426C51.3729 42.5584 49.6126 41.7375 48.3262 42.4145Z",
    fill: "#ACADB2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4209 40.3834C52.6593 40.7811 52.4731 41.9152 52.9893 42.9054C53.5056 43.8956 54.555 44.3864 55.3082 43.9887C56.0699 43.5909 56.2561 42.4568 55.7398 41.4666C55.2151 40.468 54.1742 39.9856 53.4209 40.3834Z",
    fill: "#ACADB2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2568 37.1504C86.859 34.3576 84.811 32.3349 82.6782 32.6311C80.5455 32.9358 79.1322 35.4409 79.5299 38.2337C79.9192 41.0265 81.9758 43.0493 84.1085 42.7446C86.2412 42.4399 87.6546 39.9348 87.2568 37.142V37.1504Z",
    fill: "#ACADB2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4386 30.4984C85.6911 29.7537 85.9196 27.8325 84.9464 26.1907C83.9816 24.5573 82.1789 23.8294 80.9264 24.5657C79.6738 25.302 79.4453 27.2316 80.4186 28.865C81.3834 30.5069 83.186 31.2262 84.4386 30.49V30.4984Z",
    fill: "#ACADB2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7499 30.2447C79.1744 29.2799 78.1165 28.8483 77.3802 29.2884C76.6439 29.7285 76.5085 30.8625 77.0755 31.8273C77.651 32.7921 78.7089 33.2237 79.4452 32.7837C80.1815 32.3436 80.3169 31.2095 79.7499 30.2447Z",
    fill: "#ACADB2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.6365 33.9764C63.8224 29.2539 61.5458 22.0687 64.5586 17.9217C67.58 13.7748 74.7398 14.2403 80.5625 18.9542C86.3767 23.6767 88.6533 30.8704 85.6319 35.0089C82.6106 39.1643 75.4423 38.6988 69.6281 33.9764H69.6365Z",
    fill: "url(#paint1_radial_646_34198)",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M45.9565 41.3731C46.7267 38.8426 50.6451 39.892 54.7159 43.7174C58.7782 47.5343 61.4526 52.6799 60.6824 55.2104C59.9123 57.7324 55.9938 56.6914 51.923 52.8745C47.8607 49.0576 45.1864 43.9036 45.9565 41.3815V41.3731Z",
    fill: "url(#paint2_radial_646_34198)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7811 42.4822C61.9686 30.5915 52.0752 21.1974 39.9813 21.1974C27.8875 21.1974 17.994 30.5915 17.1816 42.4822C8.1683 42.9308 1 50.3699 1 59.4932C1 68.6165 8.62531 76.5211 18.0279 76.5211H61.9179C71.3204 76.5211 78.9458 68.8958 78.9458 59.4932C78.9458 50.0906 71.7775 42.9308 62.7726 42.4822H62.7811Z",
    fill: "url(#paint3_radial_646_34198)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.9811 44.5982C33.566 39.3933 31.0609 31.4803 34.3869 26.9102C37.7129 22.3401 45.6091 22.8563 52.0241 28.0527C58.4308 33.2491 60.9359 41.1791 57.6098 45.7407C54.2838 50.3108 46.3877 49.7946 39.9811 44.5982Z",
    fill: "url(#paint4_radial_646_34198)",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M62.8996 59.9757C57.864 55.8879 55.8921 49.6675 58.5072 46.0707C61.1223 42.4823 67.3258 42.8801 72.3614 46.9678C77.397 51.0555 79.3689 57.2844 76.7538 60.8727C74.1387 64.4696 67.9352 64.0634 62.8996 59.9757Z",
    fill: "url(#paint5_radial_646_34198)",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.1781 60.5425C9.46275 54.7452 5.13807 51.9524 3.5216 54.3051C1.9136 56.6579 3.6147 63.2676 7.33003 69.0649C11.0538 74.8622 15.37 77.655 16.9865 75.3107C18.5945 72.9495 16.8934 66.3482 13.1781 60.5425Z",
    fill: "url(#paint6_radial_646_34198)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_646_34198",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.3797 22.0013) rotate(180) scale(43.3822 43.3822)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#EDE9F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9DA2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_646_34198",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(206.985 -158.492) rotate(126.03) scale(9.30669 13.537)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_646_34198",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(524.298 498.067) rotate(-136.79) scale(10.1239 4.27593)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_646_34198",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.8071 33.0201) rotate(-180) scale(59.4622 43.4074)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D5F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85BCF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_646_34198",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(177.301 -147.817) rotate(126.03) scale(10.2628 14.9277)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_646_34198",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199.78 -131.857) rotate(126.03) scale(8.06015 11.7239)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_646_34198",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1217 64.4484) rotate(-25.71) scale(4.12156 11.9937)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherCloudyMoon);
export default __webpack_public_path__ + "static/media/weather-cloudy-moon.07cd6691c25bbaa95c79f7a9ba283448.svg";
export { ForwardRef as ReactComponent };